export default function DueDatePresets({ onSelect }) {
  const presets = [
    { label: "In 2 hours", offset: 2 * 3600000 },
    {
      label: "Tomorrow 10 AM",
      getDate: () => {
        const d = new Date();
        d.setDate(d.getDate() + 1);
        d.setHours(10, 0, 0, 0);
        return d;
      },
    },
    { label: "In 3 days", offset: 3 * 86400000 },
    { label: "Next week", offset: 7 * 86400000 },
  ];

  const pick = (p) => {
    const d = p.getDate ? p.getDate() : new Date(Date.now() + p.offset);
    onSelect(d.toISOString().slice(0, 16)); // datetime-local format
  };

  return (
    <div className="flex flex-wrap gap-1.5">
      {presets.map((p) => (
        <button
          key={p.label}
          type="button"
          onClick={() => pick(p)}
          className="rounded-full border border-navy/10 bg-cream/60 px-3 py-1 text-xs font-medium text-navy hover:bg-cream"
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
